export const siteOfflineRoute = '/pages/offline/index'

const siteOfflineAt = new Date('2026-06-30T19:00:00+08:00').getTime()

export const isSiteOffline = () => Date.now() >= siteOfflineAt

export const getSiteOfflineDelay = () => Math.max(siteOfflineAt - Date.now(), 0)

export const normalizeRoutePath = (url: string) => {
  const path = url.split('?')[0]
  return path.startsWith('/') ? path : `/${path}`
}

export const isSiteOfflineRoute = (url: string) => normalizeRoutePath(url) === siteOfflineRoute

export const redirectToSiteOffline = () => {
  uni.reLaunch({
    url: siteOfflineRoute,
  })
}
